



















































import { defineComponent } from '@vue/composition-api';
import HelpTooltip from '@front-app/components/dropdowns/HelpTooltip.vue';

export default defineComponent({
	components: {
		HelpTooltip,
	},
	props: {
		checked: {
			type: Boolean,
			required: true,
		},
		value: {
			required: true,
			type: [String, Number, Boolean, Object, Array],
		},
		noVisibleLabel: Boolean,
		isDisabled: Boolean,
		isReversed: Boolean,
		isCentered: Boolean,
		withHelp: Boolean,
		isLoading: Boolean,
	},
	setup() {
		return {};
	},
});
